<script>
  export default {
    components: {

    },
    props: {
      orderItem: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {

      }
    },
    computed: {

    },
    created() {

    },
    methods: {

    }
}
</script>

<template>
  <div :class="$style.sectionMemberCourseList">
    <div
      v-for="(info,$index2) in orderItem" 
      :key="$index2"
      class="row sectionMemberCourseList__list__item no-gutters"
    >
      <div class="col-md-3 col-12 title">
        {{ info.title }}
      </div>
      <div class="col-md-9 col-12 content">
        <div 
          v-for="(textItem,$index3) in info.textList" 
          :key="$index3"
          :class="textItem.class"
        >  
            {{ textItem.title }}:
          <span class="color-gray-7">
            {{ textItem.text }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.sectionMemberCourseList {
  :global {
    .sectionMemberCourseList {
      &__list {
        &__title {

        }
        &__item {
          padding: 3.125rem 2.25rem;
          @include max-md {
            padding: 1.25rem $container-gap;
          }
          &:first-child {
            @include max-md {
              padding-top: 0;
            }
          }

          &:not(:last-child) {
            border-bottom: 1px solid #E6E6E6;
          }

          .title {
            font-size: 20px;
            font-weight: 500;

            @include max-md {
              padding-bottom: 0.75rem;
              font-size: 1rem;
            }
          }

          .content {
            font-size: 1.125rem;
            line-height: 1.85;
            color: $color-gray-6;
            @include max-md {
              font-size: 0.875rem;
            }
          }
        }
      }
    }
  }
  
}
 
</style>